import { useQuery } from 'urql';
import { GetSocialAnalyticsPostTypeTimeSeriesQuery, GetSocialAnalyticsPostTypeTimeSeriesQueryVariables } from '@frontend/gql/social/graphql';
import { getSocialAnalyticsPostTypeTimeSeries } from '../graphql';

interface UseAnalyticsDataProps {
  clientId: string | undefined;
  pauseQuery?: boolean;
  queryVariables: GetSocialAnalyticsPostTypeTimeSeriesQueryVariables;
}

interface UseAnalyticsDataReturn {
  data: GetSocialAnalyticsPostTypeTimeSeriesQuery | undefined;
  fetching: boolean;
}

export const useAnalyticsPostTypesSeriesData = ({
  clientId,
  queryVariables,
  pauseQuery = false,
}: UseAnalyticsDataProps): UseAnalyticsDataReturn => {
  const [{ data, fetching }] = useQuery({
    query: getSocialAnalyticsPostTypeTimeSeries,
    variables: {
      ...queryVariables,
    },
    pause: !clientId || pauseQuery,
  });

  return {
    data,
    fetching,
  };
};
